import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {map} from 'rxjs/operators';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-select',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <mat-form-field class="demo-full-width margin-top" [hideRequiredMarker]="field?.hideRequiredMarker" [formGroup]="group" appearance="outline">
      <mat-label>{{field?.label}}</mat-label>
      <mat-select [placeholder]="field?.label" [formControlName]="field?.key" (selectionChange)="selectionChange($event)" [multiple]="field.multiple" (focus)="focus()">
        <app-mat-select-search [(ngModel)]="searchValue"  ngDefaultControl [ngModelOptions]="{standalone: true}"></app-mat-select-search>
        @if (hasFocus && field.useObservable && field.options) {
          @if (!field.removeUnderscore) {
            <span>
              @for (item of (field.options | async) || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue; track item) {
                <mat-option [value]="item.value">
                  {{item.name}}
                </mat-option>
              }
            </span>
          } @else {
            @for (item of (field.options | async) || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue; track item) {
              <mat-option [value]="item.value">
                {{ item.name | replace: '_' : ' '}}
              </mat-option>
            }
          }
        }
        @if (hasFocus && !field.useObservable && field.options) {
          @if (!field.removeUnderscore) {
            <span>
              @for (item of field.options || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue; track item) {
                <mat-option [value]="item.value">
                  {{item.name}}
                </mat-option>
              }
            </span>
          } @else {
            @for (item of field.options || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue; track item) {
              <mat-option [value]="item.value">
                {{ item.name | replace: '_' : ' '}}
              </mat-option>
            }
          }
        }
      </mat-select>
      <mat-hint ><strong>{{field.hint}}</strong> </mat-hint>
      @for (validation of field.validations; track validation) {
        <ng-container ngProjectAs="mat-error">
          @if (group.get(field.key).hasError(validation.name)) {
            <mat-error>{{validation.message}}</mat-error>
          }
        </ng-container>
      }
    </mat-form-field>
    `,
    // host: {'class': 'col-md-6'},
    styles: ['.additional-selection { opacity: 0.75; font-size: 0.75em; }'],
    standalone: false
})
export class SelectComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  @Output() selectedValue = new EventEmitter();

  searchValue = '';
  filterVal;
  searchParameters: string;
  hasFocus = false;
  hasManyOptions = false;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() { }
  ngOnInit() {

    this.hasFocus = !((this.field.options || []).length > 50);
    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
    this.filterVal = this.group.get(this.field.filterValueKey) ? this.group.get(this.field.filterValueKey).value : null;
    this.searchParameters = this.field.searchParameters ? this.field.searchParameters.join() : 'name';
  }


  selectionChange(event) {
    let object: any;
    if (this.field.useObservable) {
      object = this.field.options.pipe(map((items: any[]) => items.find(element => element.value == event.value)));
    } else {
      object = this.field.options.find(element => element.value == event.value);
    }
    this.selectedValue.emit({ value: event.value, field: this.field, object });
  }
  focus() {
    this.hasFocus = true;
  }
}
